/**
 * MY ROOMS — the shell already fetches the person's rooms (GET /my/agentic-networks, WorkbenchShell); it publishes them
 * here so other surfaces (the Inbox's room-lifecycle items, LIFECYCLE.md §5) reuse them without a second request.
 */
const store = { rooms: [], subs: new Set() };

export function publishMyRooms(rooms) {
  store.rooms = Array.isArray(rooms) ? rooms : [];
  store.subs.forEach((f) => f(store.rooms));
}

export function getMyRooms() { return store.rooms; }

export function subscribeMyRooms(fn) {
  store.subs.add(fn);
  return () => store.subs.delete(fn);
}

/** Test hook. */
export function __resetMyRooms() { store.rooms = []; store.subs.clear(); }
